<template>
  <div class="rew19_aro_wrap shop">
    <div class="rew19_contents_inner rew19-contents-inner--wide">
      <h2 class="rew19-contents-title">4+1 정기구매 진행현황</h2>
      <p style="text-align: center;">※ 해당 프로그램은 2월 29일 결제 완료한 건까지 적용됩니다. (3월 1일부터 구매하신 분들께는 4+1 프로그램 사은품이 증정되지 않습니다.)</p>
      <div class="rew19_tabwrap">
        <ul class="rew19_linetab_pop nav nav-tabs nav-stacked">
            <li class="active"><a href="#">유지중인 4+1 정기구매</a></li>
            <li><router-link :to="{name:'fourPlusDetail'}">4+1 정기구매 History</router-link></li>
        </ul>
      </div>

      <div class="rew19_stateTable_wrap" v-for="(item) in viewData.retentionList" :key="item.index">
        <div class="rew19_title-withbtn">
          <em>[{{item.aroNo}}] {{item.title}}</em>
          <a @click="openFourPlusGiftDialog(item)" class="rew19_btn_border">사은품</a>
        </div>

        <div v-if="item.paymentCheck == 'Y' && item.transferCheck == 'N'">
        </div>
        <div v-else>
        <table class="rew19-table-col">
          <caption>콜 테이블</caption>
          <colgroup>
            <col />
            <col />
            <col />
            <col />
          </colgroup>
          <thead>
            <tr>
              <th class="table-col__head">1회 유지</th>
              <th class="table-col__head">2회 유지</th>
              <th class="table-col__head">3회 유지</th>
              <th class="table-col__head">4회 유지</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(retention) in item.retentionDetail" :key="retention.index">
              <td class="table-col__data">
                <img v-if="retention.data1 != '' && retention.data1 == '진행'"
                  src="https://resource2018.nuskinkorea.co.kr/images/aro/stamp_state_mb.png"
                  alt="진행 4+1"
                  title="진행중"
                  class="state"
                />
              </td>
              <td class="table-col__data">
                <img v-if="retention.data2 != '' && retention.data2 == '진행'"
                  src="https://resource2018.nuskinkorea.co.kr/images/aro/stamp_state_mb.png"
                  alt="진행 4+1"
                  title="진행중"
                  class="state"
                />
              </td>
              <td class="table-col__data">
                <img v-if="retention.data3 != '' && retention.data3 == '진행'"
                  src="https://resource2018.nuskinkorea.co.kr/images/aro/stamp_state_mb.png"
                  alt="진행 4+1"
                  title="진행중"
                  class="state"
                />
              </td>
              <td class="table-col__data">
                <span>{{retention.data4}}</span>
                <img v-if="retention.data4 != '' && retention.data4.indexOf('달성') > -1"
                  src="https://resource2018.nuskinkorea.co.kr/images/aro/stamp_completion_mb.png"
                  alt="완료 4+1"
                  title="완료"
                  class="completion"
                />
              </td>
            </tr>
            <tr v-if="!item.retentionDetail || item.retentionDetail <= 0">
              <td colspan="4" class="table-col__data no_data">4+1 정기구매 진행내역이 없습니다.</td>
            </tr>
          </tbody>
        </table>
        </div>

        <span class="rew19_infoStar">{{item.message}}</span>
      </div>

       <!-- 4+1 리스트가 없는 경우 -->
      <div class="rew19_order_box noList" v-if="viewData.retentionList <= 0">
            <p class="flex">4+1 정기구매 진행내역이 없습니다.</p>
      </div>

      <div
        class="rew19_backgrayInfo" v-if="viewData.retentionList > 0"
      >*4+1 정기구매는 4개월 연속으로 매 월 1개 이상 구매해야 유지되며, 사은품은 해당 요건을 만족하는 구매 수량에 따라 지급됩니다</div>
    </div>
    <!--rew19_contents_inner-->

    <four-plus-gift-dialog
      :show="fourPlusGiftDialogShow"
      @close="changeFourPlusGift"
      ref="fourPlusGiftDialog"
    ></four-plus-gift-dialog>
  </div>
</template>
<script>
import AroBase from "@/components/base/AroBase";
import FourPlusGiftDialog from '@/components/popup/FourPlusGiftDialog';

import * as Const from "@/utils/const";
import * as ErrMsg from "@/utils/error_msg";

export default {
  name: "fourPlusList",
  extends: AroBase,
  components: {FourPlusGiftDialog},
  computed: {},

  data: () => ({
    //View Data
    viewData : {
      retentionList : []
    },

    //popup
    //배송일 변경
    fourPlusGiftDialogShow : false,
    fourPlusGiftDialog : {},

    testText: ""
  }),

  created() {},
  mounted() {
    let _this = this;

    _this.loadList();
  },

  methods: {
    /**
     * API Request
     */

    // 리텐션 프로그램 자세히 보기
    apiGetRetentions(){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/retentions`, {
          params: {
            rType : 1
          }
        });
    },

    // 리텐션 사은품 수정
    apiRetentionsUpdateGift(gift){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/retentions/update_gift`, {
          params: {
            ...gift
          }
        });
    },

    initData(paramData){
      let _this = this;

      _this.viewData = {
        ...paramData
      };
    },

    //데이터 로드
    loadList(){
      let _this = this;

      //show loading
      _this.$showLoading();
      _this.apiGetRetentions().then(res=>{

        if (res.status === 200 && res.data.status === "0000") {
          _this.viewData = {...res.data};

          let retentionList = res.data.retentionList;
          _this.viewData.retentionList = retentionList.filter(item => {
            if(item.retentionDetail != ''){
              let data4 = '';
              item.retentionDetail.filter(detail => {
                if(detail.data4.indexOf('달성') == -1){
                  var dataArr = detail.data4.split('[');
                  detail.data4 = dataArr[0];
                }
                return detail;
              });
            }
            return item;
          });
        }else{
          //console.error(res);
          _this.$dialogs.alert(res.data.message).then(res => {});
        }

      }).catch(()=>{
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{

        //hide loading
        _this.$hideLoading();
      });
    },

    //상세 이동
    onClickDetail(){
      let _this = this;
      _this.$router.push(`${_this.$aroBasePath}/fourPlusDetail`);
    },

    //Open dialog 사은품 변경
    openFourPlusGiftDialog(item){
      let _this = this;

      let isAgelocMe = false;

      if(item.title.indexOf('에이지락 미') > -1){
        isAgelocMe = true;
      }

      //pass data to dialog
      _this.fourPlusGiftDialog = {
        ..._this.fourPlusGiftDialog,
        aroNo : item.aroNo,
        mSeq : item.mSeq,
        defaultProduct : item.defaultProduct,
        defaultAgmCode : item.defaultAgmCode,
        productCode : item.productCode,
        agmCode : item.agmCode,
        agmName : item.agmName,
        agmDetail : item.agmDetail,
        isAgelocMe : isAgelocMe,
        memberId : _this.getMemberId()
      };

      _this.$refs.fourPlusGiftDialog.initData(_this.fourPlusGiftDialog);
      _this.fourPlusGiftDialogShow = true;
    },

    // 사은품 변경
    changeFourPlusGift(isOk, data){
      let _this = this;

      _this.fourPlusGiftDialogShow = false;

      if(!isOk){
        //Do nothing
        return;
      }

      let gift = {
        adpNo : data.aroNo,
        mSeq : data.mSeq,
        productCode : data.productCode,
        defaultProduct : data.defaultProduct,
        agmCode : data.agmCode,
        agmName : data.agmName,
        agmDetail : data.agmDetail
      }

      _this.$showLoading();
      _this.apiRetentionsUpdateGift(gift).then(res=>{

        if (res.status === 200 && res.data.status === "0000") {
          _this.$dialogs.alert("사은품을 변경 하였습니다.")
          .then(res => {});

          _this.loadList();
          return;
        }else{
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
          .then(res => {});
        }

      }).catch((err)=>{
        console.error(err);
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
         _this.$hideLoading();
      });
    },
  }
};
</script>
<style>
.rew19_btn_border, .rew19_btn_next{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/my/aro/fourPlusList.vue